import React, { Component } from "react";
import {
  View,
  TouchableOpacity,
  Image,
  Dimensions,
  Pressable,
  ScrollView
} from "react-native";

import * as Animatable from "react-native-animatable";
import { WHITE } from "react-native-material-color";
// import ActionSheet from 'react-native-actionsheet';

import * as Styles from "../utils/Styles";
import * as Commons from "../utils/Commons";
import { STRINGS } from "../utils/Strings";
import Header from "../components/Header";
import Text from "../components/Text";
let height = Dimensions.get("window").height;
let width = Commons.getWidth();
let marginTop = 0;
let styles = {};
const arrowRight = require("../images/arrowright.png");
const arrowRight2 = require("../images/arrowright2.png");
const chevron = require("../images/chevronDown.png");
const chevron2 = require("../images/chevronDown.png");
const imgSuppliers = require("../images/Services/suppliers.jpeg");
const imgProviders = require("../images/Services/porviders2.jpeg");
const imgCompliant = require("../images/Services/compliant.png");
const imgImport1 = require("../images/Services/import1.png");
const imgProduct1 = require("../images/Services/product1.png");
const imgMarketing = require("../images/Services/marketing.png");
const imgTenders = require("../images/Services/tenders.png");
const imgCompliance = require("../images/Services/stamp2.png");
const imgStorage = require("../images/Services/storage.png");
const imgMarketKnowledge = require("../images/Services/marketingKnowledge.png");
const imgSales = require("../images/Services/sales.png");
const imgItServices = require("../images/Services/itservice.png");
const imgGoodsCoordinator = require("../images/Services/goodsCoordinator2.jpeg");
const imgDiverse = require("../images/Services/diverse.png");
const imgOnTimeDelv = require("../images/Services/onTImeDelv.png");
const imgOrderingServices = require("../images/Services/orderingService.png");
const imgInnovativeProducts = require("../images/Services/innovative.png");
const clicked = {};
let isMobile = false;
class Service extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isScrolled: false,
      hideScrollTopButton: true,
    };
  }
  Pressables = {};
  Pressed = {};

  async componentDidMount() {

  }

  renderPressableButton = (componentRef, text, onPress) => {
    const isHovered = this.state.hoveredComponent && this.Pressables[componentRef] == this.state.hoveredComponent;
    return (
      <Pressable
        ref={el => (this.Pressables[componentRef] = el)}
        onHoverIn={() => this.setState({ hoveredComponent: this.Pressables[componentRef] })}
        onHoverOut={() => this.setState({ hoveredComponent: undefined })}
        style={{ justifyContent: 'center', alignItems: 'center' }}>
        <TouchableOpacity onPress={onPress}
          style={[isHovered ? Styles.ButtonStyleHovered : Styles.ButtonStyle, isMobile && { width: width - 40, borderRadius: 40 }]}>
          <Text style={isHovered ? Styles.ButtonTextStyleHovered : Styles.ButtonTextStyle}>{text}</Text>
        </TouchableOpacity>
      </Pressable>
    )
  }

  renderPressableLink = (text, textStyle, onPress) => {
    const componentRef = text;
    const isHovered = this.state.hoveredComponent && this.Pressables[componentRef] == this.state.hoveredComponent;
    const color = isHovered ? '#52c0ee' : '#3B627F';
    return (
      <Pressable
        ref={el => (this.Pressables[componentRef] = el)}
        onHoverIn={() => this.setState({ hoveredComponent: this.Pressables[componentRef] })}
        onHoverOut={() => this.setState({ hoveredComponent: undefined })} >
        <TouchableOpacity onPress={onPress} style={{
          flexDirection: "row", alignSelf: "flex-start", alignItems: "center", justifyContent: "center", gap: 8,
          border: '1.5px solid transparent',
          borderBottomColor: color
        }}>
          <Text style={[Styles.TextStyle2, isHovered && { color }, textStyle, {
            fontSize: 15
          }]}>{text}</Text>
          <Image source={isHovered ? arrowRight2 : arrowRight} style={{ height: 12, width: 14, marginBottom: -2 }} resizeMode="contain" />
        </TouchableOpacity>
      </Pressable>
    )
  }


  // this is for the service renderPart1 buttons
  renderPressableLink3 = (text, textStyle, onPress) => {
    const componentRef = text;
    const isHovered = this.state.hoveredComponent && this.Pressables[componentRef] == this.state.hoveredComponent;
    const color = isHovered ? '#52c0ee' : '#3B627F';
    return (
      <Pressable
        ref={el => (this.Pressables[componentRef] = el)}
        onHoverIn={() => this.setState({ hoveredComponent: this.Pressables[componentRef] })}
        onHoverOut={() => this.setState({ hoveredComponent: undefined })}
        style={{ height: 56 }}>
        <TouchableOpacity onPress={onPress} style={{
          flexDirection: "row", alignSelf: "flex-start", alignItems: "center", justifyContent: "center", gap: 8,
          border: '1.5px solid transparent',
          borderBottomColor: color,
          width: width * 0.25,
        }}>

          <Text style={[Styles.TextStyle5, isHovered && { color }, textStyle, {
            fontSize: 22.5,
            paddingTop: 10,
          }]}>{text}</Text>
          <Image source={isHovered} style={{ height: 12, width: 14, marginBottom: -2 }} resizeMode="contain" />
        </TouchableOpacity>
      </Pressable>
    )
  }

  //this is for the renderPart2 buttons
  renderPressableButtonPart2 = (componentRef, onPress, imgRef) => {
    const isHovered = this.state.hoveredComponent && this.Pressables[componentRef] == this.state.hoveredComponent;
    return (
      <Pressable
        ref={el => (this.Pressables[componentRef] = el)}
        onHoverIn={() => this.setState({ hoveredComponent: this.Pressables[componentRef] })}
        onHoverOut={() => this.setState({ hoveredComponent: undefined })} >
        <TouchableOpacity onPress={onPress} style={{ alignItems: 'center' }}>
          <Animatable.Image ref={el => (clicked[imgRef + "img"] = el)} source={isHovered ? chevron2 : chevron} style={{ height: 20, width: 14, marginTop: 10 }} resizeMode="contain" />
        </TouchableOpacity>
      </Pressable>
    )
  }

  showSolutionsForSuppliers = (key) => {
    if (clicked[key + ""]) {
      this.hideSolutionsForSuppliers(key);
      return;
    }
    clicked[key + "img"].animate({ 0: { rotate: '0deg' }, 1: { rotate: '180deg' } }, 500);
    clicked[key + ""] = true;
    if (key == 1) {
      this.regulatoryService.animate({ 0: { height: 0, opacity: 0 }, 1: { height: 60, opacity: 1 } }, 1000);
      this.regulatoryOpacity.animate({ 0: { opacity: 0.3 }, 1: { opacity: 1 } }, 1000);
    }
    if (key == 2) {
      this.importation.animate({ 0: { height: 0, opacity: 0 }, 1: { height: 100, opacity: 1 } }, 1000);
      this.importationOpacity.animate({ 0: { opacity: 0.3 }, 1: { opacity: 1 } }, 1000);
    }
    if (key == 3) {
      this.distributionServices.animate({ 0: { height: 0, opacity: 0 }, 1: { height: 140, opacity: 1 } }, 1000);
      this.distributionOpacity.animate({ 0: { opacity: 0.3 }, 1: { opacity: 1 } }, 1000);
    }
    if (key == 4) {
      this.marketing.animate({ 0: { height: 0, opacity: 0 }, 1: { height: 100, opacity: 1 } }, 1000);
      this.marketingOpacity.animate({ 0: { opacity: 0.3 }, 1: { opacity: 1 } }, 1000);
    }
    if (key == 5) {
      this.compliance.animate({ 0: { height: 0, opacity: 0 }, 1: { height: 120, opacity: 1 } }, 1000);
      this.complianceOpacity.animate({ 0: { opacity: 0.3 }, 1: { opacity: 1 } }, 1000);
    }
    if (key == 6) {
      this.storage.animate({ 0: { height: 0, opacity: 0 }, 1: { height: 100, opacity: 1 } }, 1000);
      this.storageOpacity.animate({ 0: { opacity: 0.3 }, 1: { opacity: 1 } }, 1000);
    }
    if (key == 7) {
      this.marketKnowledge.animate({ 0: { height: 0, opacity: 0 }, 1: { height: 30, opacity: 1 } }, 1000);
      this.marketKnowledgeOpacity.animate({ 0: { opacity: 0.3 }, 1: { opacity: 1 } }, 1000);
    }
    if (key == 8) {
      this.sales.animate({ 0: { height: 0, opacity: 0 }, 1: { height: 140, opacity: 1 } }, 1000);
      this.salesOpacity.animate({ 0: { opacity: 0.3 }, 1: { opacity: 1 } }, 1000);
    }
    if (key == 9) {
      this.itService.animate({ 0: { height: 0, opacity: 0 }, 1: { height: 120, opacity: 1 } }, 1000);
      this.itServiceOpacity.animate({ 0: { opacity: 0.3 }, 1: { opacity: 1 } }, 1000);
    }
  }

  hideSolutionsForSuppliers = (key) => {
    clicked[key + ""] = false;
    clicked[key + "img"].animate({ 0: { rotate: '180deg' }, 1: { rotate: '0deg' } }, 500);
    if (key == 1) {
      this.regulatoryService.animate({ 0: { height: 60, opacity: 1 }, 1: { height: 0, opacity: 0 } }, 1000);
      this.regulatoryOpacity.animate({ 0: { opacity: 1 }, 1: { opacity: 0.3 } }, 1000);
    }
    if (key == 2) {
      this.importation.animate({ 0: { height: 100, opacity: 1 }, 1: { height: 0, opacity: 0 } }, 1000);
      this.importationOpacity.animate({ 0: { opacity: 1 }, 1: { opacity: 0.3 } }, 1000);
    }
    if (key == 3) {
      this.distributionServices.animate({ 0: { height: 140, opacity: 1 }, 1: { height: 0, opacity: 0 } }, 1000);
      this.distributionOpacity.animate({ 0: { opacity: 1 }, 1: { opacity: 0.3 } }, 1000);
    }
    if (key == 4) {
      this.marketing.animate({ 0: { height: 100, opacity: 1 }, 1: { height: 0, opacity: 0 } }, 1000);
      this.marketingOpacity.animate({ 0: { opacity: 1 }, 1: { opacity: 0.3 } }, 1000);
    }
    if (key == 5) {
      this.compliance.animate({ 0: { height: 120, opacity: 1 }, 1: { height: 0, opacity: 0 } }, 1000);
      this.complianceOpacity.animate({ 0: { opacity: 1 }, 1: { opacity: 0.3 } }, 1000);
    }
    if (key == 6) {
      this.storage.animate({ 0: { height: 100, opacity: 1 }, 1: { height: 0, opacity: 0 } }, 1000);
      this.storageOpacity.animate({ 0: { opacity: 1 }, 1: { opacity: 0.3 } }, 1000);
    }
    if (key == 7) {
      this.marketKnowledge.animate({ 0: { height: 30, opacity: 1 }, 1: { height: 0, opacity: 0 } }, 1000);
      this.marketKnowledgeOpacity.animate({ 0: { opacity: 1 }, 1: { opacity: 0.3 } }, 1000);
    }
    if (key == 8) {
      this.sales.animate({ 0: { height: 140, opacity: 1 }, 1: { height: 0, opacity: 0 } }, 1000);
      this.salesOpacity.animate({ 0: { opacity: 1 }, 1: { opacity: 0.3 } }, 1000);
    }
    if (key == 9) {
      this.itService.animate({ 0: { height: 120, opacity: 1 }, 1: { height: 0, opacity: 0 } }, 1000);
      this.itServiceOpacity.animate({ 0: { opacity: 1 }, 1: { opacity: 0.3 } }, 1000);
    }
  }

  showSolutionsForProviders = (key) => {
    if (clicked[key + ""]) {
      this.hideSolutionsForProviders(key);
      return;
    }
    clicked["x" + key + "img"].animate({ 0: { rotate: '0deg' }, 1: { rotate: '180deg' } }, 500);
    clicked[key + ""] = true;
    if (key == 1) {
      this.diversePortfolio.animate({ 0: { height: 0, opacity: 0 }, 1: { height: 65, opacity: 1 } }, 1000);
      this.diversePortfolioOpacity.animate({ 0: { opacity: 0.3 }, 1: { opacity: 1 } }, 1000);
    }
    if (key == 2) {
      this.onTimeDelivery.animate({ 0: { height: 0, opacity: 0 }, 1: { height: 60, opacity: 1 } }, 1000);
      this.onTimeDeliveryOpacity.animate({ 0: { opacity: 0.3 }, 1: { opacity: 1 } }, 1000);
    }
    if (key == 3) {
      this.orderingService.animate({ 0: { height: 0, opacity: 0 }, 1: { height: 45, opacity: 1 } }, 1000);
      this.orderingServiceOpacity.animate({ 0: { opacity: 0.3 }, 1: { opacity: 1 } }, 1000);
    }
    if (key == 4) {
      this.providerMarketKnowledge.animate({ 0: { height: 0, opacity: 0 }, 1: { height: 80, opacity: 1 } }, 1000);
      this.providerMarketKnowledgeOpacity.animate({ 0: { opacity: 0.3 }, 1: { opacity: 1 } }, 1000);
    }
    if (key == 5) {
      this.innovativeProducts.animate({ 0: { height: 170, opacity: 0 }, 1: { height: 100, opacity: 1 } }, 1000);
      this.innovativeProductsOpacity.animate({ 0: { opacity: 0.3 }, 1: { opacity: 1 } }, 1000);
    }
    if (key == 6) {
      this.providerItService.animate({ 0: { height: 0, opacity: 0 }, 1: { height: 150, opacity: 1 } }, 1000);
      this.providerItServiceOpacity.animate({ 0: { opacity: 0.3 }, 1: { opacity: 1 } }, 1000);
    }
  }

  hideSolutionsForProviders = (key) => {
    clicked[key + ""] = false;
    clicked["x" + key + "img"].animate({ 0: { rotate: '180deg' }, 1: { rotate: '0deg' } }, 500);
    if (key == 1) {
      this.diversePortfolio.animate({ 0: { height: 65, opacity: 1 }, 1: { height: 0, opacity: 0 } }, 1000);
      this.diversePortfolioOpacity.animate({ 0: { opacity: 1 }, 1: { opacity: 0.3 } }, 1000);
    }
    if (key == 2) {
      this.onTimeDelivery.animate({ 0: { height: 60, opacity: 1 }, 1: { height: 0, opacity: 0 } }, 1000);
      this.onTimeDeliveryOpacity.animate({ 0: { opacity: 1 }, 1: { opacity: 0.3 } }, 1000);
    }
    if (key == 3) {
      this.orderingService.animate({ 0: { height: 45, opacity: 1 }, 1: { height: 0, opacity: 0 } }, 1000);
      this.orderingServiceOpacity.animate({ 0: { opacity: 1 }, 1: { opacity: 0.3 } }, 1000);
    }
    if (key == 4) {
      this.providerMarketKnowledge.animate({ 0: { height: 80, opacity: 1 }, 1: { height: 0, opacity: 0 } }, 1000);
      this.providerMarketKnowledgeOpacity.animate({ 0: { opacity: 1 }, 1: { opacity: 0.3 } }, 1000);
    }
    if (key == 5) {
      this.innovativeProducts.animate({ 0: { height: 100, opacity: 1 }, 1: { height: 0, opacity: 0 } }, 1000);
      this.innovativeProductsOpacity.animate({ 0: { opacity: 1 }, 1: { opacity: 0.3 } }, 1000);
    }
    if (key == 6) {
      this.providerItService.animate({ 0: { height: 150, opacity: 1 }, 1: { height: 0, opacity: 0 } }, 1000);
      this.providerItServiceOpacity.animate({ 0: { opacity: 1 }, 1: { opacity: 0.3 } }, 1000);
    }
  }

  renderRegulatoryService = () => {
    return (<Animatable.View ref={el => (this.regulatoryService = el)} style={[{ height: 0, opacity: 0 }]}>
      <Text style={[Styles.TextStyle2, { fontSize: 12.8, color: '#808080' }]}>
        Jordanian FDA. Our regular follow-ups on applications
        {'\n'}help ensure timely approvals.
      </Text>
    </Animatable.View>
    )
  }

  renderImportation = () => {
    return (<Animatable.View ref={el => (this.importation = el)} style={[{ height: 0, opacity: 0 }]}>
      <Text style={[Styles.TextStyle2, { fontSize: 12.8, color: '#808080' }]}>
        (Supply Chain Security Program) . Our strong compliance
        {'\n'}and transparency with customs authorities ensure a smooth
        {'\n'}clearance process, faster goods release times, enhanced
        {'\n'}security, and improved risk management for our imports.
      </Text>
    </Animatable.View>
    )
  }

  renderDistributionServices = () => {
    return (<Animatable.View ref={el => (this.distributionServices = el)} style={[{ height: 0, opacity: 0 }]}>
      <Text style={[Styles.TextStyle2, { fontSize: 12.8, color: '#808080' }]}>
        delivery is paramount, facilitated by our temperature-
        {'\n'}controlled van fleet. Additionally, our extensive distribution
        {'\n'}network, with over 100 scheduled trips per week, covers
        {'\n'}most of Jordan's geographical areas. We offer 24/7
        {'\n'}delivery for emergency cases, ensuring your needs are
        {'\n'}met swiftly and efficiently.
      </Text>
    </Animatable.View>
    )
  }

  renderMarketing = () => {
    return (<Animatable.View ref={el => (this.marketing = el)} style={[{ height: 0, opacity: 0 }]}>
      <Text style={[Styles.TextStyle2, { fontSize: 12.8, color: '#808080' }]}>
        professionals and customers, engage in educational events
        {'\n'}and conferences, and strictly adhere to compliance
        {'\n'}policies. We provide ongoing training, product education,
        {'\n'}and pharmacovigilance.
      </Text>
    </Animatable.View>
    )
  }

  renderComplianceSystem = () => {
    return (<Animatable.View ref={el => (this.compliance = el)} style={[{ height: 0, opacity: 0 }]}>
      <Text style={[Styles.TextStyle2, { fontSize: 12.8, color: '#808080' }]}>
        of Conduct. Our strong stance against bribery and
        {'\n'}corruption is evident in our zero-tolerance approach, which
        {'\n'}encourages our staff to report any suspected compliance
        {'\n'}issues through a whistleblowing policy and a dedicated
        {'\n'}compliance reporting system.
      </Text>
    </Animatable.View>
    )
  }

  renderStorageFacilities = () => {
    return (<Animatable.View ref={el => (this.storage = el)} style={[{ height: 0, opacity: 0 }]}>
      <Text style={[Styles.TextStyle2, { fontSize: 12.8, color: '#808080' }]}>
        evolving needs of our business partners. Our storage
        {'\n'}facilities ensure the integrity of cold chain products
        {'\n'}throughout the supply chain, providing a reliable and
        {'\n'}secure environment for your products.
      </Text>
    </Animatable.View>
    )
  }

  renderMarketKnowledge = () => {
    return (<Animatable.View ref={el => (this.marketKnowledge = el)} style={[{ height: 0, opacity: 0 }]}>
      <Text style={[Styles.TextStyle2, { fontSize: 12.8, color: '#808080' }]}>
        growth.
        {'\n'}
      </Text>
    </Animatable.View>
    )
  }

  renderSales = () => {
    return (<Animatable.View ref={el => (this.sales = el)} style={[{ height: 0, opacity: 0 }]}>
      <Text style={[Styles.TextStyle2, { fontSize: 12.8, color: '#808080' }]}>
        from bi-monthly visits by our pharmaceutical sales team,
        {'\n'}equipped with connected hand-held personal digital
        {'\n'}assistants for seamless operations. Our team prides itself
        {'\n'}on stability and experience, with minimal turnover.
        {'\n'}Moreover, our Call Center efficiently manages an average
        {'\n'}of 16,000 calls each month.
      </Text>
    </Animatable.View>
    )
  }

  renderItServices = () => {
    return (<Animatable.View ref={el => (this.itService = el)} style={[{ height: 0, opacity: 0 }]}>
      <Text style={[Styles.TextStyle2, { fontSize: 12.8, color: '#808080' }]}>
        Management System (WMS) streamlines logistics for our
        {'\n'}suppliers products, ensuring precise order processing and
        {'\n'}efficient dispatch. Furthermore, our secure web-based
        {'\n'}reporting portal enables partners to access and generate
        {'\n'}reports tailored to their specific needs.
      </Text>
    </Animatable.View>
    )
  }

  renderDiversePortfolio = () => {
    return (<Animatable.View ref={el => (this.diversePortfolio = el)} style={[{ height: 0, opacity: 0 }]}>
      <Text style={[Styles.TextStyle2, { fontSize: 12.8, color: '#808080' }]}>
        empowers you to adapt to evolving healthcare and
        {'\n'}consumer industry needs.
        {'\n'}
      </Text>
    </Animatable.View>
    )
  }

  renderOnTimeDelv = () => {
    return (<Animatable.View ref={el => (this.onTimeDelivery = el)} style={[{ height: 0, opacity: 0 }]}>
      <Text style={[Styles.TextStyle2, { fontSize: 12.8, color: '#808080' }]}>
        capturing, parcel labeling and real-time tracking at
        {'\n'}every stage.
      </Text>
    </Animatable.View>
    )
  }

  renderOrderingServices = () => {
    return (<Animatable.View ref={el => (this.orderingService = el)} style={[{ height: 0, opacity: 0 }]}>
      <Text style={[Styles.TextStyle2, { fontSize: 12.8, color: '#808080' }]}>
        further improve our ordering system.
      </Text>
    </Animatable.View>
    )
  }

  renderProvidersMarketKnowledge = () => {
    return (<Animatable.View ref={el => (this.providerMarketKnowledge = el)} style={[{ height: 0, opacity: 0 }]}>
      <Text style={[Styles.TextStyle2, { fontSize: 12.8, color: '#808080' }]}>
        pharmaceutical trends, identify opportunities for effective
        {'\n'}product procurement, and tailor your offerings to meet the
        {'\n'}evolving needs of their patients and customers.
      </Text>
    </Animatable.View>
    )
  }

  renderProvidersItServices = () => {
    return (<Animatable.View ref={el => (this.providerItService = el)} style={[{ height: 0, opacity: 0 }]}>
      <Text style={[Styles.TextStyle2, { fontSize: 12.8, color: '#808080' }]}>
        Additionally, our Warehouse Management System (WMS)
        {'\n'}ensures near-perfect order accuracy, translating orders
        {'\n'}precisely and allowing healthcare providers to enjoy
        {'\n'}hassle-free operations. Our secure web-based reporting
        {'\n'}portal further empowers partners to access and generate
        {'\n'}customized reports, catering to their unique requirements.
      </Text>
    </Animatable.View>
    )
  }

  renderMobile = () => {
    return (
      <View style={styles.container}>
        <Header
          title={STRINGS.company_name}
          leftView={Styles.drawerButtonDark(this.props.navigation)}
          light={true}
          navigation={this.props.navigation}
          hideHeader={this.state.hideHeader}
          hideScrollTopButton={this.state.hideScrollTopButton}
          self={this}
          selectedTab={""}
        />
        <ScrollView
          ref={ref => this.mainScrollView = ref}
          scrollEventThrottle={200} showsVerticalScrollIndicator={false} onScroll={(e) => Commons.onHeaderScroll(e, this)}>
          {Commons.loadFonts(this)}
          <View style={{ width, paddingHorizontal: 20, gap: 50, textAlign: 'center' }}>
            {Styles.renderVSeparator(100)}
            {this.renderPart1Mobile()}
            {this.renderPart2Mobile()}
            {/* {this.renderPart3Mobile()} */}
            {/* {this.renderPart4Mobile()} */}
            {/* {this.renderPart5Mobile()} */}
            {this.renderPart6Mobile()}
            {Styles.renderVSeparator(0)}
          </View>
          {Commons.renderFooter({}, this)}
        </ScrollView >
      </View>

    );
  }

  render() {
    Commons.resizeHandle(window, this, () => {
      width = this.width;
      height = this.height;
    });
    width = Dimensions.get("window").width;
    isMobile = Commons.isMobile();
    if (isMobile) {
      styles = this.styles();
      return this.renderMobile();
    }
    width = Commons.getWidth();
    styles = this.styles();
    marginTop = 300;
    return (
      <View style={styles.container}>
        <Header
          title={STRINGS.company_name}
          leftView={Styles.drawerButtonDark(this.props.navigation)}
          light={true}
          navigation={this.props.navigation}
          hideHeader={this.state.hideHeader}
          hideScrollTopButton={this.state.hideScrollTopButton}
          self={this}
          selectedTab={"Services"}
        />
        <ScrollView
          ref={ref => this.mainScrollView = ref}
          scrollEventThrottle={200} showsVerticalScrollIndicator={false} onScroll={(e) => Commons.onHeaderScroll(e, this)}
          style={{ gap: 84 }}>
          {Commons.loadFonts(this)}
          {this.renderPart1()}
          {this.renderPart2()}
          {this.renderPart3()}
          {this.renderPart4()}
          {this.renderPart5()}
          {this.renderPart6()}

          {Commons.renderFooter({}, this)}
        </ScrollView >

      </View >
    );
  }

  renderPart1 = () => {
    return (<View style={{
      paddingTop: 200,
      paddingLeft: 164,
      height: 400,
      flexDirection: 'column',
      gap: 30
    }}>
      <Text style={[Styles.TextStyle3, { fontSize: 28, lineHeight: 38 }]}>
        If You Strive To Make A Difference{'\n'}We Can Make It Possible
      </Text>
      <Text style={[Styles.TextStyle4]}>
        Our comprehensive suite of services is designed to optimize supply-chains for both
        {'\n'}suppliers and healthcare providers, ensuring products reach those who need them
        {'\n'}efficiently and reliably.
      </Text>

    </View>)
  }

  renderPart1Mobile = () => {
    return (<View style={{
      gap: 30,
      textAlign: 'left'
    }}>
      <Text style={[Styles.TextStyle3, {}]}>
        If You Strive To Make A Difference{'\n'}We Can Make It Possible
      </Text>
      <Text style={[Styles.TextStyle2, { fontWeight: '400', letterSpacing: 0.08, fontSize: 16, color: Styles.appColor3 }]}>
        Our comprehensive suite of services is designed to optimize supply-chains for both
        suppliers and healthcare providers, ensuring products reach those who need them
        efficiently and reliably.
      </Text>

    </View>)
  }



  renderPart2 = () => {
    var gap = 115;
    if (width <= 1100) { gap = 20 }
    var paddingLeft = width - 1350;
    if (paddingLeft < 10) { paddingLeft = 10; }
    const isHovered1 = this.state.hoveredComponent && this.Pressables['pharmadiv'] == this.state.hoveredComponent;
    const isHovered2 = this.state.hoveredComponent && this.Pressables['parapharmadiv'] == this.state.hoveredComponent;
    this.isHovered1 = isHovered1
    this.isHovered2 = isHovered2
    return (<View style={{ paddingLeft: 164, height: 500, marginTop: 60, justifyContent: 'center' }}>
      {Styles.renderVSeparator(35)}
      <View style={{
        gap: gap,
        flexDirection: "row",
        gap: 115
      }}>
        <Pressable
          style={{ cursor: 'normal', marginLeft: 72 }}
          ref={el => (this.Pressables['pharmadiv'] = el)}
          onHoverIn={() => this.setState({ hoveredComponent: this.Pressables['pharmadiv'] })}
          onHoverOut={() => this.setState({ hoveredComponent: undefined })}
        >
          <TouchableOpacity onPress={() => this.mainScrollView.scrollTo({ animated: true, y: 1000 })}>
            <Animatable.View ref={el => (this.pharmadiv = el)} style={[{ gap: 20 }]}>
              <Animatable.Text ref={el => (this.pharmadivText1 = el)} style={[Styles.TextStyle1, { letterSpacing: -0.5, fontSize: 28 }]}>Solutions for Suppliers</Animatable.Text>
              <Image source={imgSuppliers} style={{ height: 308, width: 426 }} contentFit="cover" />
              <Animatable.Text ref={el => (this.pharmadivText2 = el)} style={[Styles.TextStyle2]}>Services that we can provide for international and local
                {'\n'}pharmaceutical and parapharmaceutical suppliers
                {'\n'}
              </Animatable.Text>
            </Animatable.View>
          </TouchableOpacity>
          {this.renderPressableButtonPart2('Solution for Suppliers', () => this.mainScrollView.scrollTo({ animated: true, y: 1000 }))}
        </Pressable>

        <Pressable
          style={{ cursor: 'normal' }}
          ref={el => (this.Pressables['parapharmadiv'] = el)}
          onHoverIn={() => this.setState({ hoveredComponent: this.Pressables['parapharmadiv'] })}
          onHoverOut={() => this.setState({ hoveredComponent: undefined })}
        >
          <View style={{ flexGrow: 1 }} />
          <TouchableOpacity onPress={() => this.mainScrollView.scrollTo({ animated: true, y: 2800 })}>
            <Animatable.View ref={el => (this.parapharmadiv = el)} style={[{ gap: 20 }]}>
              <Animatable.Text ref={el => (this.parapharmadivText1 = el)} style={[Styles.TextStyle1, { letterSpacing: -0.5, fontSize: 28 }]}>Solutions for Providers</Animatable.Text>
              <Image source={imgProviders} style={{ height: 308, width: 426 }} contentFit="cover" />
              <Animatable.Text ref={el => (this.parapharmadivText2 = el)} style={Styles.TextStyle2}>Services offered to pharmacies, para-shops healthcare
                {'\n'}institutions and healthcare providers in Jordan.
                {'\n'}
              </Animatable.Text>
            </Animatable.View>
          </TouchableOpacity>
          {this.renderPressableButtonPart2('Solution for Providers', () => this.mainScrollView.scrollTo({ animated: true, y: 2800 }))}
        </Pressable>
      </View>
    </View>)
  }


  renderPart2Mobile = () => {
    var gap = 115;
    if (width <= 1100) { gap = 20 }
    var paddingLeft = width - 1350;
    if (paddingLeft < 10) { paddingLeft = 10; }
    const isHovered1 = this.state.hoveredComponent && this.Pressables['pharmadiv'] == this.state.hoveredComponent;
    const isHovered2 = this.state.hoveredComponent && this.Pressables['parapharmadiv'] == this.state.hoveredComponent;
    this.isHovered1 = isHovered1
    this.isHovered2 = isHovered2
    return (<View style={{ gap: 50, textAlign: 'left', paddingVertical: 50 }}>
      <Pressable
        style={{ cursor: 'normal' }}
        ref={el => (this.Pressables['pharmadiv'] = el)}
        onHoverIn={() => this.setState({ hoveredComponent: this.Pressables['pharmadiv'] })}
        onHoverOut={() => this.setState({ hoveredComponent: undefined })}
      >
        {/* <TouchableOpacity onPress={() => this.mainScrollView.scrollTo({ animated: true, y: 1000 })}> */}
        <Animatable.View ref={el => (this.pharmadiv = el)} style={[{ gap: 20 }]}>
          <Animatable.Text ref={el => (this.pharmadivText1 = el)} style={[Styles.TextStyle1, { letterSpacing: -0.5, fontSize: 28 }]}>Solutions for Suppliers</Animatable.Text>
          <Animatable.Text ref={el => (this.pharmadivText2 = el)} style={[Styles.TextStyle2]}>Services that we can provide for international and local
            {'\n'}pharmaceutical and parapharmaceutical suppliers
            {'\n'}
          </Animatable.Text>
          <Image source={imgSuppliers} style={{ height: 0.66 * (width - 40), width: width - 40 }} resizeMode="cover" />
          <Text style={Styles.TextStyle2}>
            We understand that successful pharmaceutical and healthcare product
            suppliers require a trusted and strategic partner. We offer a range of
            services designed to support and amplify your presence in the
            Jordanian market.
          </Text>
        </Animatable.View>
        {/* </TouchableOpacity> */}
        {/* {this.renderPressableButtonPart2('Solution for Suppliers', () => this.mainScrollView.scrollTo({ animated: true, y: 1000 }))} */}
      </Pressable>
      <View style={{ gap: 20, paddingVertical: 50 }}>{this.renderPart3Mobile()}</View>
      <Pressable
        style={{ cursor: 'normal' }}
        ref={el => (this.Pressables['parapharmadiv'] = el)}
        onHoverIn={() => this.setState({ hoveredComponent: this.Pressables['parapharmadiv'] })}
        onHoverOut={() => this.setState({ hoveredComponent: undefined })}
      >
        <View style={{ flexGrow: 1 }} />
        {/* <TouchableOpacity onPress={() => this.mainScrollView.scrollTo({ animated: true, y: 2800 })}> */}
        <Animatable.View ref={el => (this.parapharmadiv = el)} style={[{ gap: 20 }]}>
          <Animatable.Text ref={el => (this.parapharmadivText1 = el)} style={[Styles.TextStyle1, { letterSpacing: -0.5, fontSize: 28 }]}>Solutions for Providers</Animatable.Text>
          <Animatable.Text ref={el => (this.parapharmadivText2 = el)} style={Styles.TextStyle2}>Services offered to pharmacies, para-shops healthcare
            {'\n'}institutions and healthcare providers in Jordan.
            {'\n'}
          </Animatable.Text>
          <Image source={imgProviders} style={{ height: 0.66 * (width - 40), width: width - 40 }} resizeMode="cover" />
          <Text style={Styles.TextStyle2}>
            Healthcare providers play a critical role in delivering quality care. We
            offer a suite of solutions designed to empower healthcare providers
            and enhance their ability to serve the community effectively.
          </Text>
        </Animatable.View>
        {/* </TouchableOpacity> */}
        {/* {this.renderPressableButtonPart2('Solution for Providers', () => this.mainScrollView.scrollTo({ animated: true, y: 2800 }))} */}
      </Pressable>
      <View style={{ gap: 20, paddingVertical: 50 }}>{this.renderPart4Mobile()}</View>
    </View>)
  }


  renderPart3Mobile = () => {
    const regServices = [
      { height: 140, img: imgCompliant, title: 'Regulatory Services', text: `Our Regulatory Services enable the swift introduction of products into the Jordanian market while ensuring local compliance. We offer comprehensive price analysis, facilitate process, and maintain a collaborative relationship with the Jordanian FDA. Our regular follow-ups on applications help ensure timely approvals.` },
      { height: 180, img: imgImport1, title: 'Importation', text: `Our dedication to compliance has earned us a spot on the 'Customs Golden List' recognising our exceptional cooperation with customs authorities and meeting the rigorous (91) requirements of The Golden List Award (Supply Chain Security Program) . Our strong compliance and transparency with customs authorities ensure a smooth clearance process, faster goods release times, enhanced security, and improved risk management for our imports.` },
      { height: 200, img: imgProduct1, title: 'Distribution Services', text: `Our distribution services are a multi-generational strength, on the pillars of delivering products quickly, anticipating demand, efficiently integrating new products, and adapting to market changes. Timely and accurate delivery is paramount, facilitated by our temperature-controlled van fleet. Additionally, our extensive distribution network, with over 100 scheduled trips per week, covers most of Jordan's geographical areas. We offer 24/7 delivery for emergency cases, ensuring your needs are met swiftly and efficiently.` },
      { height: 160, img: imgMarketing, title: 'Marketing', text: `We conduct market research, marketing plans, and execute marketing strategies. Our representatives handle product launches, detailing, and customer support. We maintain continuous interaction with healthcare professionals and customers, engage in educational events and conferences, and strictly adhere to compliance policies. We provide ongoing training, product education, and pharmacovigilance.` },
      { height: 90, img: imgTenders, title: 'Tenders', text: `Being among the top suppliers in Jordan for the tender business we have excellent knowledge of the procedures and have historical data related to all previous tenders in addition to an excellent network in all tender institutions.` },
      { height: 190, img: imgCompliance, title: 'Compliance System', text: `JDS management ensures that all business activities strictly adhere to applicable laws and regulations. This dedication to ethical business conduct is deeply rooted in our core values, as reflected in our ABAC policies and Code of Conduct. Our strong stance against bribery and corruption is evident in our zero-tolerance approach, which encourages our staff to report any suspected compliance issues through a whistleblowing policy and a dedicated compliance reporting system.` },
      { height: 160, img: imgStorage, title: 'Storage Facilities', text: `Discover the convenience of our storage facility, strategically located near the airport and major highways. Offering extensive storage capacity and optimal conditions, our solutions are adaptable, catering to the evolving needs of our business partners. Our storage facilities ensure the integrity of cold chain products throughout the supply chain, providing a reliable and secure environment for your products.` },
      { height: 90, img: imgMarketKnowledge, title: 'Market Knowledge', text: `Our insights into local and regional healthcare trends, consumer preferences, and regulatory landscapes empower suppliers to optimize their offerings, enhance patient and consumer care, and achieve sustainable growth.` },
      { height: 200, img: imgSales, title: 'Sales', text: `Our sales force ranks among the most extensive in Jordan, encompassing beauty advisors, merchandisers, and business unit managers who evaluate new opportunities and oversee existing partnerships. Pharmacies benefit from bi-monthly visits by our pharmaceutical sales team, equipped with connected hand-held personal digital assistants for seamless operations. Our team prides itself on stability and experience, with minimal turnover. Moreover, our Call Center efficiently manages an average of 16,000 calls each month.` },
      { height: 130, img: imgItServices, title: 'IT Services', text: `JDS leverages Oracle E-Business Suite R12, a robust system, enabling us to share data with suppliers. This suite supports both supply chain and financial functions, providing access to essential reports. Our Warehouse Management System (WMS) streamlines logistics for our suppliers products, ensuring precise order processing and efficient dispatch. Furthermore, our secure web-based reporting portal enables partners to access and generate reports tailored to their specific needs.` },
    ];
    return regServices.map((service, index) => {
      return (
        <Pressable
          style={{ flexDirection: 'column', gap: 0, alignItems: 'center' }}
          onPress={() => {
            if (this.Pressed[service.title + ".."]) {
              this.Pressables[service.title + ".."].animate({ 0: { opacity: 1, height: service.height }, 1: { opacity: 0, height: 0 } }, 1000);
            } else {
              this.Pressables[service.title + ".."].animate({ 0: { opacity: 0, height: 0 }, 1: { opacity: 1, height: service.height } }, 1000);
            }
            this.Pressed[service.title + ".."] = !this.Pressed[service.title + ".."];
          }}>
          {index != 0 &&
            <View style={{ backgroundColor: Styles.appColor1, height: .5, width: width - 40, marginBottom: 20 }}></View>
          }
          <View style={{ flexDirection: 'row', gap: 20, width: width - 60, alignItems: "center" }}>
            <Image source={service.img} style={{ height: 36, width: 36 }} contentFit="cover"></Image>
            <Text style={[Styles.TextStyle2, { fontWeight: '400', fontSize: 20, marginTop: -5, width: width - 140 }]}>{service.title}</Text>
            <Animatable.Image source={chevron} style={{ height: 15, width: 10 }} resizeMode="contain" />
          </View>

          <Animatable.View ref={ref => this.Pressables[service.title + ".."] = ref}
            style={{ marginTop: 10, height: 0, opacity: 0, width: width - 40 }}>
            <Text style={[Styles.TextStyle2, { fontSize: 12.8, color: '#808080' }]}>
              {service.text}
            </Text>
          </Animatable.View>
        </Pressable>);
    });
  }

  renderPart4Mobile = () => {
    const regServices = [
      { height: 110, img: imgDiverse, title: 'Diverse Portfolio', text: `Enhance patient and consumer care with our extensive range of high-quality pharmaceutical and consumer products, spanning from cutting-edge medications to innovative healthcare solutions. Our diverse portfolio empowers you to adapt to evolving healthcare and consumer industry needs.` },
      { height: 110, img: imgOnTimeDelv, title: 'On-Time Delivery', text: `Our delivery team ensures to provide on-time and scheduled delivery services. In critical situations, we offer 24/7 delivery to meet lifesaving demands. promptly track and trace your order through barcode capturing, parcel labeling and real-time tracking at every stage.` },
      { height: 110, img: imgOrderingServices, title: 'Ordering Services', text: `Our user-friendly ordering Call Center System and our sales team order placement simplifies the procurement process, ensuring timely access to essential supplies. An ordering application is currently being developed to further improve our ordering system.` },
      { height: 160, img: imgMarketKnowledge, title: 'Market Knowledge', text: `We conduct market research, marketing plans, and execute marketing strategies. Our representatives handle product launches, detailing, and customer support. We maintain continuous interaction with healthcare professionals and customers, engage in educational events and conferences, and strictly adhere to compliance policies. We provide ongoing training, product education, and pharmacovigilance.` },
      { height: 60, img: imgInnovativeProducts, title: 'Innovative Products', text: `Stay ahead with our fast introduction of innovative healthcare products and services, keeping your offerings up to date.` },
      { height: 100, img: imgItServices, title: 'IT Services', text: `Oracle E-Business Suite R12 is utilized to facilitate the flow of data and reporting for healthcare providers. This comprehensive system enhances our supply chain and finance operations, delivering vital insights and reports. Additionally, our Warehouse Management System (WMS) ensures near-perfect order accuracy, translating orders precisely and allowing healthcare providers to enjoy hassle-free operations. Our secure web-based reporting portal further empowers partners to access and generate customized reports, catering to their unique requirements.` },
    ];
    return regServices.map((service, index) => {
      return (
        <Pressable
          style={{ flexDirection: 'column', gap: 0, alignItems: 'center' }}
          onPress={() => {
            if (this.Pressed[service.title]) {
              this.Pressables[service.title].animate({ 0: { opacity: 1, height: service.height }, 1: { opacity: 0, height: 0 } }, 1000);
            } else {
              this.Pressables[service.title].animate({ 0: { opacity: 0, height: 0 }, 1: { opacity: 1, height: service.height } }, 1000);
            }
            this.Pressed[service.title] = !this.Pressed[service.title];
          }}>
          {index != 0 &&
            <View style={{ backgroundColor: Styles.appColor1, height: .5, width: width - 40, marginBottom: 20 }}></View>
          }
          <View style={{ flexDirection: 'row', gap: 20, width: width - 60, alignItems: "center" }}>
            <Image source={service.img} style={{ height: 36, width: 36 }} contentFit="cover"></Image>
            <Text style={[Styles.TextStyle2, { fontWeight: '400', fontSize: 20, marginTop: -5, width: width - 140 }]}>{service.title}</Text>
            <Animatable.Image source={chevron} style={{ height: 15, width: 10 }} resizeMode="contain" />
          </View>

          <Animatable.View ref={ref => this.Pressables[service.title] = ref}
            style={{ marginTop: 10, height: 0, opacity: 0, width: width - 40 }}>
            <Text style={[Styles.TextStyle2, { fontSize: 12.8, color: '#808080' }]}>
              {service.text}
            </Text>
          </Animatable.View>
        </Pressable>);
    });
  }



  renderPart3 = () => {
    return (<View style={{
      display: 'flex',
      width,
      justifyContent: 'center',
      alignItems: 'flex-start',
      alignContent: 'flex-start',
      flexWrap: 'wrap',
      paddingLeft: 164,
      gap: 30,
      marginTop: marginTop - 180,
    }}>
      <View style={{ display: 'flex', flexDirection: 'column', gap: 30, alignItems: 'flex-start' }}>
        <Text style={Styles.TextStyle3}>Solutions for Suppliers</Text>
        <Text style={[Styles.TextStyle2, { marginBottom: 46, fontSize: 16, color: Styles.appColor3 }]}>
          We understand that successful pharmaceutical and healthcare product
          {'\n'}suppliers require a trusted and strategic partner. We offer a range of
          {'\n'}services designed to support and amplify your presence in the
          {'\n'}Jordanian market.
        </Text>

        <View style={{ width: 902, justifyContent: 'space-between', gap: width - 1373, flexDirection: 'row' }}>
          <Pressable
            // onHoverOut={() => { this.hideSolutionsForSuppliers(1) }}
            // onHoverIn={() => { this.showSolutionsForSuppliers(1) }}
            style={{ flexDirection: 'column', gap: 0, width: 387.196, alignItems: 'center' }}
            onPress={() => this.showSolutionsForSuppliers(1)}>
            <View style={{ paddingLeft: 30, flexDirection: 'row', gap: 30, width: 387.196, alignItems: "center" }}>
              <Image source={imgCompliant} style={{ height: 51, width: 51 }} contentFit="cover"></Image>
              <Text style={[Styles.TextStyle2, { fontWeight: '400', color: '#52C0EE', fontSize: 20 }]}>Regulatory Services</Text>
            </View>
            <Animatable.View style={{ marginTop: 10 }}>
              <Text style={[Styles.TextStyle2, { fontSize: 12.8, color: '#808080' }]}>
                Our Regulatory Services enable the swift introduction of
                {'\n'}products into the Jordanian market while ensuring local
                {'\n'}compliance. We offer comprehensive price analysis, facilitate
                {'\n'}
                <Animatable.Text ref={el => (this.regulatoryOpacity = el)} style={[Styles.TextStyle2, { fontSize: 12.8, color: '#808080', height: 1, opacity: 0.3 }]}>
                  process, and maintain a collaborative relationship with the
                  {'\n'}
                </Animatable.Text>
                {this.renderRegulatoryService()}
              </Text>
            </Animatable.View>
            {this.renderPressableButtonPart2('Regulatory', () => this.showSolutionsForSuppliers(1), "1")}
          </Pressable>

          {/* Compliance System */}
          <Pressable
            // onHoverOut={() => { this.hideSolutionsForSuppliers(5) }}
            // onHoverIn={() => { this.showSolutionsForSuppliers(5) }}
            style={{ flexDirection: 'column', gap: 0, width: 387.196, alignItems: 'center' }}
            onPress={() => this.showSolutionsForSuppliers(5)}>
            <View style={{ paddingLeft: 30, flexDirection: 'row', gap: 30, width: 387.196, alignItems: "center" }}>
              <Image source={imgCompliance} style={{ height: 51, width: 51 }} contentFit="cover"></Image>
              <Text style={[Styles.TextStyle2, { fontWeight: '400', color: '#52C0EE', fontSize: 20 }]}>Compliance System</Text>
            </View>
            <Animatable.View style={{ marginTop: 10 }}>
              <Text style={[Styles.TextStyle2, { fontSize: 12.8, color: '#808080' }]}>
                JDS management ensures that all business activities
                {'\n'}strictly adhere to applicable laws and regulations. This
                {'\n'}dedication to ethical business conduct is deeply rooted in
                {'\n'}
                <Animatable.Text ref={el => (this.complianceOpacity = el)} style={[Styles.TextStyle2, { fontSize: 12.8, color: '#808080', height: 1, opacity: 0.3 }]}>
                  our core values, as reflected in our ABAC policies and Code
                  {'\n'}
                </Animatable.Text>
                {this.renderComplianceSystem()}
              </Text>
            </Animatable.View>
            {this.renderPressableButtonPart2('Compliance', () => this.showSolutionsForSuppliers(5), "5")}
          </Pressable>
        </View>

        <View style={{ width: 902, justifyContent: 'space-between', gap: width - 1373, flexDirection: 'row' }}>
          {/* Importation */}
          <Pressable
            // onHoverOut={() => { this.hideSolutionsForSuppliers(2) }}
            // onHoverIn={() => { this.showSolutionsForSuppliers(2) }}
            style={{ flexDirection: 'column', gap: 0, width: 387.196, alignItems: 'center' }}
            onPress={() => this.showSolutionsForSuppliers(2)}>
            <View style={{ paddingLeft: 30, flexDirection: 'row', gap: 30, width: 387.196, alignItems: "center" }}>
              <Image source={imgImport1} style={{ height: 51, width: 51 }} contentFit="cover"></Image>
              <Text style={[Styles.TextStyle2, { fontWeight: '400', color: '#52C0EE', fontSize: 20 }]}>Importation</Text>
            </View>
            <Animatable.View style={{ marginTop: 10 }}>
              <Text style={[Styles.TextStyle2, { fontSize: 12.8, color: '#808080' }]}>
                Our dedication to compliance has earned us a spot on
                {'\n'}the 'Customs Golden List' recognising our exceptional
                {'\n'}cooperation with customs authorities and meeting the
                {'\n'}
                <Animatable.Text ref={el => (this.importationOpacity = el)} style={[Styles.TextStyle2, { fontSize: 12.8, color: '#808080', height: 1, opacity: 0.3 }]}>
                  rigorous (91) requirements of The Golden List Award
                  {'\n'}
                </Animatable.Text>
                {this.renderImportation()}
              </Text>
            </Animatable.View>
            {this.renderPressableButtonPart2('Importation', () => this.showSolutionsForSuppliers(2), "2")}
          </Pressable>

          {/* Storage Facilities */}
          <Pressable
            // onHoverOut={() => { this.hideSolutionsForSuppliers(6) }}
            // onHoverIn={() => { this.showSolutionsForSuppliers(6) }}
            style={{ flexDirection: 'column', gap: 0, width: 387.196, alignItems: 'center' }}
            onPress={() => this.showSolutionsForSuppliers(6)}>
            <View style={{ paddingLeft: 30, flexDirection: 'row', gap: 30, width: 387.196, alignItems: "center" }}>
              <Image source={imgStorage} style={{ height: 51, width: 51 }} contentFit="cover"></Image>
              <Text style={[Styles.TextStyle2, { fontWeight: '400', color: '#52C0EE', fontSize: 20 }]}>Storage Facilities</Text>
            </View>
            <Animatable.View style={{ marginTop: 10 }}>
              <Text style={[Styles.TextStyle2, { fontSize: 12.8, color: '#808080' }]}>
                Discover the convenience of our storage facility,
                {'\n'}strategically located near the airport and major highways.
                {'\n'}Offering extensive storage capacity and optimal
                {'\n'}
                <Animatable.Text ref={el => (this.storageOpacity = el)} style={[Styles.TextStyle2, { fontSize: 12.8, color: '#808080', height: 1, opacity: 0.3 }]}>
                  conditions, our solutions are adaptable, catering to the
                  {'\n'}
                </Animatable.Text>
                {this.renderStorageFacilities()}
              </Text>
            </Animatable.View>
            {this.renderPressableButtonPart2('Storage', () => this.showSolutionsForSuppliers(6), "6")}
          </Pressable>
        </View>

        <View style={{ width: 902, justifyContent: 'space-between', gap: width - 1373, flexDirection: 'row' }}>
          {/* Distribution Services */}
          <Pressable
            // onHoverOut={() => { this.hideSolutionsForSuppliers(3) }}
            // onHoverIn={() => { this.showSolutionsForSuppliers(3) }}
            style={{ flexDirection: 'column', gap: 0, width: 387.196, alignItems: 'center' }}
            onPress={() => this.showSolutionsForSuppliers(3)}>
            <View style={{ paddingLeft: 30, flexDirection: 'row', gap: 30, width: 387.196, alignItems: "center" }}>
              <Image source={imgProduct1} style={{ height: 51, width: 51 }} contentFit="cover"></Image>
              <Text style={[Styles.TextStyle2, { fontWeight: '400', color: '#52C0EE', fontSize: 20 }]}>Distribution Services</Text>
            </View>
            <Animatable.View style={{ marginTop: 10 }}>
              <Text style={[Styles.TextStyle2, { fontSize: 12.8, color: '#808080' }]}>
                Our distribution services are a multi-generational strength ,
                {'\n'} on the pillars of delivering products quickly,
                {'\n'}anticipating demand, efficiently integrating new products,
                {'\n'}
                <Animatable.Text ref={el => (this.distributionOpacity = el)} style={[Styles.TextStyle2, { fontSize: 12.8, color: '#808080', height: 1, opacity: 0.3 }]}>
                  and adapting to market changes. Timely and accurate
                  {'\n'}
                </Animatable.Text>
                {this.renderDistributionServices()}
              </Text>
            </Animatable.View>
            {this.renderPressableButtonPart2('Distribution', () => this.showSolutionsForSuppliers(3), "3")}
          </Pressable>

          {/* Market Knowledge */}
          <Pressable
            // onHoverOut={() => { this.hideSolutionsForSuppliers(7) }}
            // onHoverIn={() => { this.showSolutionsForSuppliers(7) }}
            style={{ flexDirection: 'column', gap: 0, width: 387.196, alignItems: 'center' }}
            onPress={() => this.showSolutionsForSuppliers(7)}>
            <View style={{ paddingLeft: 30, flexDirection: 'row', gap: 30, width: 387.196, alignItems: "center" }}>
              <Image source={imgMarketKnowledge} style={{ height: 51, width: 51 }} contentFit="cover"></Image>
              <Text style={[Styles.TextStyle2, { fontWeight: '400', color: '#52C0EE', fontSize: 20 }]}>Market Knowledge</Text>
            </View>
            <Animatable.View style={{ marginTop: 10, marginRight: 20 }}>
              <Text style={[Styles.TextStyle2, { fontSize: 12.8, color: '#808080' }]}>
                Our insights into local and regional healthcare trends,
                {'\n'}consumer preferences, and regulatory landscapes
                {'\n'}empower suppliers to optimize their offerings, enhance
                {'\n'}
                <Animatable.Text ref={el => (this.marketKnowledgeOpacity = el)} style={[Styles.TextStyle2, { fontSize: 12.8, color: '#808080', height: 1, opacity: 0.3 }]}>
                  patient and consumer care, and achieve sustainable
                  {'\n'}
                </Animatable.Text>
                {this.renderMarketKnowledge()}
              </Text>
            </Animatable.View>
            {this.renderPressableButtonPart2('Market Knowledge', () => this.showSolutionsForSuppliers(7), "7")}
          </Pressable>
        </View>

        <View style={{ width: 902, justifyContent: 'space-between', gap: width - 1373, flexDirection: 'row' }}>
          {/* Marketing */}
          <Pressable
            // onHoverOut={() => { this.hideSolutionsForSuppliers(4) }}
            // onHoverIn={() => { this.showSolutionsForSuppliers(4) }}
            style={{ flexDirection: 'column', gap: 0, width: 387.196, alignItems: 'center', alignItems: "center" }}
            onPress={() => this.showSolutionsForSuppliers(4)}>
            <View style={{ paddingLeft: 30, flexDirection: 'row', gap: 30, width: 387.196, alignItems: "center" }}>
              <Image source={imgMarketing} style={{ height: 51, width: 51 }} contentFit="cover"></Image>
              <Text style={[Styles.TextStyle2, { fontWeight: '400', color: '#52C0EE', fontSize: 20 }]}>Marketing</Text>
            </View>
            <Animatable.View style={{ marginTop: 10 }}>
              <Text style={[Styles.TextStyle2, { fontSize: 12.8, color: '#808080' }]}>
                We conduct market research, marketing plans, and
                {'\n'}execute marketing strategies. Our representatives handle
                {'\n'}product launches, detailing, and customer support. We
                {'\n'}
                <Animatable.Text ref={el => (this.marketingOpacity = el)} style={[Styles.TextStyle2, { fontSize: 12.8, color: '#808080', height: 1, opacity: 0.3 }]}>
                  maintain continuous interaction with healthcare
                  {'\n'}
                </Animatable.Text>
                {this.renderMarketing()}
              </Text>
            </Animatable.View>
            {this.renderPressableButtonPart2('Marketing', () => this.showSolutionsForSuppliers(4), "4")}
          </Pressable>

          {/* Sales */}
          <Pressable
            // onHoverOut={() => { this.hideSolutionsForSuppliers(8) }}
            // onHoverIn={() => { this.showSolutionsForSuppliers(8) }}
            style={{ flexDirection: 'column', gap: 0, width: 387.196, alignItems: 'center' }}
            onPress={() => this.showSolutionsForSuppliers(8)}>
            <View style={{ paddingLeft: 30, flexDirection: 'row', gap: 30, width: 387.196, alignItems: "center" }}>
              <Image source={imgSales} style={{ height: 51, width: 51 }} contentFit="cover"></Image>
              <Text style={[Styles.TextStyle2, { fontWeight: '400', color: '#52C0EE', fontSize: 20 }]}>Sales</Text>
            </View>
            <Animatable.View style={{ marginTop: 10 }}>
              <Text style={[Styles.TextStyle2, { fontSize: 12.8, color: '#808080' }]}>
                Our sales force ranks among the most extensive in Jordan,
                {'\n'}encompassing beauty advisors, merchandisers, and
                {'\n'}business unit managers who evaluate new opportunities
                {'\n'}
                <Animatable.Text ref={el => (this.salesOpacity = el)} style={[Styles.TextStyle2, { fontSize: 12.8, color: '#808080', height: 1, opacity: 0.3 }]}>
                  and oversee existing partnerships. Pharmacies benefit
                  {'\n'}
                </Animatable.Text>
                {this.renderSales()}
              </Text>
            </Animatable.View>
            {this.renderPressableButtonPart2('Sales', () => this.showSolutionsForSuppliers(8), "8")}
          </Pressable>
        </View>

        <View style={{ width: 902, justifyContent: 'space-between', gap: width - 1373, flexDirection: 'row' }}>
          {/* Tenders */}
          <Pressable style={{ flexDirection: 'column', gap: 0, width: 387.196, alignItems: 'center' }}>
            <View style={{ paddingLeft: 30, flexDirection: 'row', gap: 30, width: 387.196, alignItems: "center" }}>
              <Image source={imgTenders} style={{ height: 51, width: 51 }} contentFit="cover"></Image>
              <Text style={[Styles.TextStyle2, { fontWeight: '400', color: '#52C0EE', fontSize: 20 }]}>Tenders</Text>
            </View>
            <Animatable.View style={{ marginTop: 10 }}>
              <Text style={[Styles.TextStyle2, { fontSize: 12.8, color: '#808080' }]}>
                Being among the top suppliers in Jordan for the tender
                {'\n'}business we have excellent knowledge of the procedures
                {'\n'}and have historical data related to all previous tenders in
                {'\n'}addition to an excellent network in all tender institutions.
              </Text>
            </Animatable.View>
          </Pressable>

          {/* IT Services */}
          <Pressable
            // onHoverOut={() => { this.hideSolutionsForSuppliers(9) }}
            // onHoverIn={() => { this.showSolutionsForSuppliers(9) }}
            style={{ flexDirection: 'column', gap: 0, width: 387.196, alignItems: 'center' }}
            onPress={() => this.showSolutionsForSuppliers(9)}>
            <View style={{ paddingLeft: 30, flexDirection: 'row', gap: 30, width: 387.196, alignItems: "center" }}>
              <Image source={imgItServices} style={{ height: 51, width: 51 }} contentFit="cover"></Image>
              <Text style={[Styles.TextStyle2, { fontWeight: '400', color: '#52C0EE', fontSize: 20 }]}>IT Services</Text>
            </View>
            <Animatable.View style={{ marginTop: 10 }}>
              <Text style={[Styles.TextStyle2, { fontSize: 12.8, color: '#808080' }]}>
                JDS leverages Oracle E-Business Suite R12, a robust
                {'\n'}system, enabling us to share data with suppliers. This suite
                {'\n'}supports both supply chain and financial functions,
                {'\n'}
                <Animatable.Text ref={el => (this.itServiceOpacity = el)} style={[Styles.TextStyle2, { fontSize: 12.8, color: '#808080', height: 1, opacity: 0.3 }]}>
                  providing access to essential reports. Our Warehouse
                  {'\n'}
                </Animatable.Text>
                {this.renderItServices()}
              </Text>
            </Animatable.View>
            {this.renderPressableButtonPart2('IT Service', () => this.showSolutionsForSuppliers(9), "9")}
          </Pressable>
        </View>

      </View>
    </View>

    )
  }

  renderPart4 = () => {
    return (<View style={{ width: width, height: width / 4.66, marginTop: 50, paddingLeft: 10 }}>
      <Image source={imgGoodsCoordinator} style={{ resizeMode: 'contain', width: width, height: 300 }}>

      </Image>
    </View>
    )
  }


  renderPart5 = () => {
    return (<View style={{
      display: 'flex',
      width,
      justifyContent: 'center',
      alignItems: 'flex-start',
      alignContent: 'flex-start',
      flexWrap: 'wrap',
      paddingLeft: 164,
      gap: 30,
      marginTop: marginTop - 220,
    }}>
      <View style={{ display: 'flex', flexDirection: 'column', gap: 30, alignItems: 'flex-start' }}>
        <Text style={Styles.TextStyle3}>Solutions for Healthcare Providers</Text>
        <Text style={[Styles.TextStyle2, { marginBottom: 46, color: Styles.appColor3 }]}>
          Healthcare providers play a critical role in delivering quality care. We
          {'\n'}offer a suite of solutions designed to empower healthcare providers
          {'\n'}and enhance their ability to serve the community effectively.
        </Text>
        <View style={{ width: 902, justifyContent: 'space-between', gap: width - 1373, flexDirection: 'row' }}>
          {/* Diverse Portfolio */}
          <Pressable
            // onHoverOut={() => { this.hideSolutionsForProviders(1) }}
            // onHoverIn={() => { this.showSolutionsForProviders(1) }}
            style={{ flexDirection: 'column', gap: 0, width: 387.196, alignItems: 'center' }}
            onPress={() => this.showSolutionsForProviders(1)}>
            <View style={{ paddingLeft: 30, flexDirection: 'row', gap: 30, width: 387.196, alignItems: "center" }}>
              <Image source={imgDiverse} style={{ height: 51, width: 51, marginLeft: 10 }} contentFit="cover"></Image>
              <Text style={[Styles.TextStyle2, { fontWeight: '400', color: '#52C0EE', fontSize: 20 }]}>Diverse Portfolio</Text>
            </View>
            <Animatable.View style={{ marginTop: 10 }}>
              <Text style={[Styles.TextStyle2, { fontSize: 12.8, color: '#808080' }]}>
                Enhance patient and consumer care with our extensive
                {'\n'}range of high-quality pharmaceutical and consumer
                {'\n'}products, spanning from cutting-edge medications to
                {'\n'}
                <Animatable.Text ref={el => (this.diversePortfolioOpacity = el)} style={[Styles.TextStyle2, { fontSize: 12.8, color: '#808080', height: 1, opacity: 0.3 }]}>
                  innovative healthcare solutions. Our diverse portfolio
                  {'\n'}
                </Animatable.Text>
                {this.renderDiversePortfolio()}
              </Text>
            </Animatable.View>
            {this.renderPressableButtonPart2('Diverse Portfolio', () => this.showSolutionsForProviders(1), "x1")}
          </Pressable>

          {/* Providers Market Knowledge */}
          <Pressable
            // onHoverOut={() => { this.hideSolutionsForProviders(4) }}
            // onHoverIn={() => { this.showSolutionsForProviders(4) }}
            style={{ flexDirection: 'column', gap: 0, width: 387.196, alignItems: 'center' }}
            onPress={() => this.showSolutionsForProviders(4)}>
            <View style={{ paddingLeft: 30, flexDirection: 'row', gap: 30, width: 387.196, alignItems: "center" }}>
              <Image source={imgMarketKnowledge} style={{ height: 51, width: 51, marginLeft: 5 }} contentFit="cover"></Image>
              <Text style={[Styles.TextStyle2, { fontWeight: '400', color: '#52C0EE', fontSize: 20 }]}>Market Knowledge</Text>
            </View>
            <Animatable.View style={{ marginTop: 10 }}>
              <Text style={[Styles.TextStyle2, { fontSize: 12.8, color: '#808080' }]}>
                Effectively leverage our extensive market knowledge to
                {'\n'}make informed decisions about inventory management,
                {'\n'}patient care strategies, and overall healthcare operations.
                {'\n'}
                <Animatable.Text ref={el => (this.providerMarketKnowledgeOpacity = el)} style={[Styles.TextStyle2, { fontSize: 12.8, color: '#808080', height: 1, opacity: 0.3 }]}>
                  By tapping into our expertise, you can access the latest
                  {'\n'}
                </Animatable.Text>
                {this.renderProvidersMarketKnowledge()}
              </Text>
            </Animatable.View>
            {this.renderPressableButtonPart2('Providers Market', () => this.showSolutionsForProviders(4), "x4")}
          </Pressable>
        </View>

        <View style={{ width: 902, justifyContent: 'space-between', gap: width - 1373, flexDirection: 'row' }}>
          {/* On-Time Delivery */}
          <Pressable
            // onHoverOut={() => { this.hideSolutionsForProviders(2) }}
            // onHoverIn={() => { this.showSolutionsForProviders(2) }}
            style={{ flexDirection: 'column', gap: 0, width: 387.196, alignItems: 'center' }}
            onPress={() => this.showSolutionsForProviders(2)}>
            <View style={{ paddingLeft: 30, flexDirection: 'row', gap: 30, width: 387.196 }}>
              <Image source={imgOnTimeDelv} style={{ height: 51, width: 51, marginLeft: 10 }} contentFit="cover"></Image>
              <Text style={[Styles.TextStyle2, { fontWeight: '400', color: '#52C0EE', fontSize: 20 }]}>On-Time Delivery</Text>
            </View>
            <Animatable.View style={{ marginTop: 10 }}>
              <Text style={[Styles.TextStyle2, { fontSize: 12.8, color: '#808080' }]}>
                Our delivery team ensures to provide on-time
                {'\n'}and scheduled delivery services. In critical situations,
                {'\n'}we offer 24/7 delivery to meet lifesaving demands.
                {'\n'}
                <Animatable.Text ref={el => (this.onTimeDeliveryOpacity = el)} style={[Styles.TextStyle2, { fontSize: 12.8, color: '#808080', height: 1, opacity: 0.3 }]}>
                  promptly track and trace your order through barcode
                  {'\n'}
                </Animatable.Text>
                {this.renderOnTimeDelv()}
              </Text>
            </Animatable.View>
            {this.renderPressableButtonPart2('on-Time Delv', () => this.showSolutionsForProviders(2), "x2")}
          </Pressable>

          {/* Innovative Products */}
          <Pressable
            // onHoverOut={() => { this.hideSolutionsForProviders(5) }}
            // onHoverIn={() => { this.showSolutionsForProviders(5) }}
            style={{ flexDirection: 'column', gap: 0, width: 387.196, alignItems: 'center' }}>
            <View style={{ paddingLeft: 30, flexDirection: 'row', gap: 30, width: 387.196, alignItems: "center" }}>
              <Image source={imgInnovativeProducts} style={{ height: 51, width: 51, marginLeft: 10 }} contentFit="cover"></Image>
              <Text style={[Styles.TextStyle2, { fontWeight: '400', color: '#52C0EE', fontSize: 20 }]}>Innovative Products</Text>
            </View>
            <Animatable.View style={{ marginTop: 10 }}>
              <Text style={[Styles.TextStyle2, { fontSize: 12.8, color: '#808080' }]}>
                Stay ahead with our fast introduction of innovative
                {'\n'}healthcare products and services, keeping your offerings
                {'\n'}up to date.
                {'\n'}
              </Text>
            </Animatable.View>
          </Pressable>
        </View>

        <View style={{ width: 902, justifyContent: 'space-between', gap: width - 1373, flexDirection: 'row' }}>
          {/* Ordering Services */}
          <Pressable
            // onHoverOut={() => { this.hideSolutionsForProviders(3) }}
            // onHoverIn={() => { this.showSolutionsForProviders(3) }}
            style={{ flexDirection: 'column', gap: 0, width: 387.196, alignItems: 'center' }}
            onPress={() => this.showSolutionsForProviders(3)}>
            <View style={{ paddingLeft: 30, flexDirection: 'row', gap: 30, width: 387.196, alignItems: "center" }}>
              <Image source={imgOrderingServices} style={{ height: 51, width: 51, marginLeft: 10 }} contentFit="cover"></Image>
              <Text style={[Styles.TextStyle2, { fontWeight: '400', color: '#52C0EE', fontSize: 20 }]}>Ordering Services</Text>
            </View>
            <Animatable.View style={{ marginTop: 10 }}>
              <Text style={[Styles.TextStyle2, { fontSize: 12.8, color: '#808080' }]}>
                Our user-friendly ordering Call Center System and our
                {'\n'}sales team order placement simplifies the procurement
                {'\n'}process, ensuring timely access to essential supplies. An
                {'\n'}
                <Animatable.Text ref={el => (this.orderingServiceOpacity = el)} style={[Styles.TextStyle2, { fontSize: 12.8, color: '#808080', height: 1, opacity: 0.3 }]}>
                  ordering application is currently being developed to
                  {'\n'}
                </Animatable.Text>
                {this.renderOrderingServices()}
              </Text>
            </Animatable.View>
            {this.renderPressableButtonPart2('Ordering Services', () => this.showSolutionsForProviders(3), "x3")}
          </Pressable>

          {/* IT Services */}
          <Pressable
            // onHoverOut={() => { this.hideSolutionsForProviders(6) }}
            // onHoverIn={() => { this.showSolutionsForProviders(6) }}
            style={{ paddingLeft: 30, flexDirection: 'column', gap: 0, width: 387.196, alignItems: 'center' }}
            onPress={() => this.showSolutionsForProviders(6)}>
            <View style={{ paddingLeft: 30, flexDirection: 'row', gap: 30, width: 387.196 }}>
              <Image source={imgItServices} style={{ height: 51, width: 51 }} contentFit="cover"></Image>
              <Text style={[Styles.TextStyle2, { fontWeight: '400', color: '#52C0EE', fontSize: 20 }]}>IT Services</Text>
            </View>
            <Animatable.View style={{ marginTop: 10 }}>
              <Text style={[Styles.TextStyle2, { fontSize: 12.8, color: '#808080', marginBottom: 0 }]}>
                Oracle E-Business Suite R12 is utilized to facilitate the
                {'\n'}flow of data and reporting for healthcare providers. This
                {'\n'}comprehensive system enhances our supply chain and
                {'\n'}
                <Animatable.Text ref={el => (this.providerItServiceOpacity = el)}
                  style={[Styles.TextStyle2, { fontSize: 12.8, color: '#808080', height: 1, opacity: 0.3 }]}>
                  finance operations, delivering vital insights and reports.
                  {'\n'}
                </Animatable.Text>
                {this.renderProvidersItServices()}
              </Text>
            </Animatable.View>
            {this.renderPressableButtonPart2('IT', () => this.showSolutionsForProviders(6), "x6")}
          </Pressable>
        </View>

      </View>


    </View>)
  }

  renderPart6Mobile = () => {
    return (<View style={{
      justifyContent: 'center',
      gap: "84px 131px",
    }}>
      <View style={{ flexDirection: "column", gap: 28 }}>
        <Text style={[Styles.TextStyle1, { fontSize: 28 }]}>Get In Touch!</Text>
        {this.renderPressableButton('Get In Touch', 'Contact Us', () => window.location = './contactus')}
      </View>
    </View>

    )
  }

  renderPart6 = () => {
    return (<View style={{
      display: 'flex',
      width,
      justifyContent: 'center',
      alignItems: 'flex-start',
      alignContent: 'flex-start',
      gap: "84px 131px",
      flexWrap: 'wrap',
      paddingLeft: 164,
      // paddingRight: 164,
      marginTop: marginTop - 150,
    }}>
      <View style={{ flexDirection: "column", gap: 28 }}>
        <Text style={[Styles.TextStyle1, { fontSize: 28 }]}>Get In Touch!</Text>
        {/* {this.renderPressableButton('Get In Touch', 'Contact Us', () => this.props.navigation.navigate("contactus", { v: new Date().getSeconds() }))} */}
        {this.renderPressableButton('Get In Touch', 'Contact Us', () => window.location = './contactus')}
      </View>
    </View>

    )
  }




  styles = () => ({
    container: {
      flex: 1,
      width: width,
      paddingVertical: 0,
      paddingHorizontal: 164,
      alignItems: "center",
      gap: 100,
      backgroundColor: WHITE
    },
    image: {
      width,
      height: '650px',
      flexShrink: 0,
    }
  });
}



export default Service;
